// Utility per formattare i prezzi
const formatMoney = (cents) =>
  (window.Shopify && Shopify.formatMoney)
    ? Shopify.formatMoney(cents)
    : (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: document.documentElement.getAttribute('data-shop-currency') || 'EUR'
      });

// Drawer selector
const drawerSel = '#CartDrawerContainer';
function getDrawer() { return document.querySelector(drawerSel); }

// Apri/chiudi drawer
function openDrawer() {
  const d = getDrawer();
  if (!d) return;
  d.hidden = false;
  requestAnimationFrame(() => d.classList.add('cart-drawer--open'));
}
function closeDrawer() {
  const d = getDrawer();
  if (!d) return;
  d.classList.remove('cart-drawer--open');
  setTimeout(() => { d.hidden = true; }, 450);
}

// 🔔 Aggiorna SOLO il testo dentro <cart-count> (preserva il bubble)
async function updateCartBubble() {
  try {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();

    const countEl = document.querySelector('.header__cart-count cart-count');
    const wrapper = document.querySelector('.header__cart-count');

    if (!countEl || !wrapper) return;

    if (cart.item_count > 0) {
      countEl.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
      wrapper.classList.remove('opacity-0');
      wrapper.removeAttribute('aria-hidden');
    } else {
      countEl.textContent = '';
      wrapper.classList.add('opacity-0');
      wrapper.setAttribute('aria-hidden', 'true');
    }
  } catch (e) {
    console.warn('updateCartBubble error', e);
  }
}

// Deleghe click globali
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
  if (e.target.closest('[data-cart-close],[data-cart-overlay]')) { e.preventDefault(); closeDrawer(); }
});

// Refresh drawer + bubble (via Section Rendering)
async function refreshSections(sectionList) {
  const d = getDrawer();
  const list = sectionList || (d?.dataset.sectionsToRender || '').split(',').filter(Boolean);
  if (!list.length) return;

  const res = await fetch(`/?sections=${list.join(',')}`, { credentials: 'same-origin' });
  const htmlBySection = await res.json();

  // --- Drawer ---
  if (htmlBySection['cart-drawer-custom']) {
    const temp = document.createElement('div');
    temp.innerHTML = htmlBySection['cart-drawer-custom'];
    const next = temp.querySelector(drawerSel);
    const wasOpen = d?.classList.contains('cart-drawer--open');
    if (next && d) {
      d.replaceWith(next);
      if (wasOpen) {
        next.hidden = false;
        next.classList.add('cart-drawer--open');
      }
    }
  }

  // --- Header cart bubble (sostituisco TUTTO il section wrapper Dawn) ---
  if (htmlBySection['cart-icon-bubble']) {
    const tempB = document.createElement('div');
    tempB.innerHTML = htmlBySection['cart-icon-bubble'];
    const nextSection = tempB.querySelector('#shopify-section-cart-icon-bubble');
    const currentSection = document.querySelector('#shopify-section-cart-icon-bubble');
    if (nextSection && currentSection) currentSection.replaceWith(nextSection);
  }

  bindCartItemEvents();
  renderUpsell();

  // Fallback immediato: aggiorna il numero nel bubble subito
  updateCartBubble();
}

// Intercetta fetch cart (add/change/update) e aggiorna
const _fetch = window.fetch.bind(window);
window.fetch = async (input, init) => {
  const url = typeof input === 'string' ? input : (input?.url || '');
  const isCart = /\/cart\/(add|change|update)\.js(\?|$)/.test(url);

  const resp = await _fetch(input, init);

  try {
    if (isCart && resp.ok) {
      // Aggiorna subito il numero per feedback istantaneo
      updateCartBubble();
      // Poi rendo coerenti drawer e bubble col server
      await refreshSections();
      openDrawer();
    }
  } catch (e) {
    console.error('Errore refresh drawer:', e);
  }
  return resp;
};

// Azioni quantità / rimozione
async function changeQuantity(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  // Aggiorno immediatamente il bubble + sezioni
  updateCartBubble();
  await refreshSections();
}

function bindCartItemEvents() {
  document.querySelectorAll('[data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const input = document.querySelector(`[data-qty-input][data-key="${key}"]`);
      changeQuantity(key, Number(input?.value || 1) + 1);
    });
  });
  document.querySelectorAll('[data-qty-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const input = document.querySelector(`[data-qty-input][data-key="${key}"]`);
      changeQuantity(key, Math.max(0, Number(input?.value || 1) - 1));
    });
  });
  document.querySelectorAll('[data-remove]').forEach(btn => {
    btn.addEventListener('click', () => changeQuantity(btn.dataset.key, 0));
  });
  document.querySelectorAll('[data-qty-input]').forEach(inp => {
    inp.addEventListener('change', () =>
      changeQuantity(inp.dataset.key, Math.max(0, Number(inp.value || 1)))
    );
  });
}
bindCartItemEvents();

// Correlati in carosello
async function renderUpsell() {
  const box = document.getElementById('CartUpsell');
  if (!box) return;

  const pid = box.dataset.lastProductId;
  try {
    let products = [];
    if (pid) {
      const rec = await fetch(`/recommendations/products.json?product_id=${pid}&limit=6`, { credentials: 'same-origin' }).then(r => r.json());
      products = rec?.products || [];
    }

    // fallback su collezione
    if (!products.length && box.dataset.fallbackCollection) {
      const col = box.dataset.fallbackCollection.split('/').pop();
      const html = await fetch(`/collections/${col}?view=grid-tiles`, { credentials: 'same-origin' }).then(r => r.text()).catch(() => null);
      if (html) box.innerHTML = html;
      return;
    }

    const imgUrl = (p) => (p?.featured_image?.url || p?.featured_image || p?.images?.[0]?.url || p?.images?.[0] || '');

    box.innerHTML = products.slice(0, 6).map(p => `
      <li>
        <div class="upsell-card">
          <a href="${p.url}">
            <img src="${imgUrl(p)}" alt="${p.title}">
            <div class="title" style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${p.title}</div>
          </a>
          <div class="price">${formatMoney(p.price)}</div>
          <button class="btn add-upsell" data-variant="${p.variants?.[0]?.id}">Aggiungi</button>
        </div>
      </li>
    `).join('');

    box.querySelectorAll('.add-upsell').forEach(btn => {
      btn.addEventListener('click', async () => {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(btn.dataset.variant), quantity: 1 })
        });
        // Aggiorna subito il bubble e poi le sezioni
        updateCartBubble();
        await refreshSections();
        openDrawer();
      });
    });
  } catch (e) {
    console.error('Errore upsell:', e);
    box.innerHTML = '';
  }
}

// Re-bind eventi sezione
document.addEventListener('shopify:section:load', () => bindCartItemEvents());
